module.exports = __webpack_public_path__ + "static/media/craft_start_third.e8570977.mp3";